
import { lazy, Suspense } from "react";
// import "@fontsource/poppins";
// import "@fontsource/great-vibes";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";



const Home = lazy(() => import("./Home"));
const Samantha = lazy(() => import("./Home-Samantha"));
// const KellyHome = lazy(() => import("./KellyHome"));
// const GiftyHome = lazy(() => import("./GiftyHome"));
// const Error = lazy(() => import("./components/error/ErrorPage"));






export default function App() {


 
  const baseName = process.env.REACT_APP_BASENAME;


  return (
      <BrowserRouter basename={baseName}>
        <Suspense fallback={<div className="text-center"><Spinner /></div>}>
          <Routes>
            <Route path="/samantha" element={<Samantha />} />
            {/* <Route path="/kellyharmon" element={<KellyHome />} /> */}
            <Route path="/" element={<Home />} />
            {/* <Route path="*" element={<Error />} /> */}
          </Routes>
        </Suspense>
      </BrowserRouter>
  );
}

